<template>

    <modal-container class="modal-container--short">

        <!-- Top navbar -->
        <modal-header
            :title="''"
            :right="'close-dark'"
            :noIcon="true">
        </modal-header>

        <!-- Prompt content -->
        <prompt-div class="text-dark">

            <!-- Layout body -->
            <template v-slot:body>
                <h3 class="font-lg font-weight-bolder mx-4 mt-2">In order to shop...</h3>
                <div clss="d-flex justify-content-center mt-4">Marketplace is open only for selected customers right now. Please log in or register first.</div>

                <div class="d-flex justify-content-center mt-5">
                    <button class="btn btn-primary w-50 mr-1" @click="sendExit('login')">Log in</button>
                    <button class="btn btn-primary w-50" @click="sendExit('signup')">Sign up</button>
                </div>
            </template>
        </prompt-div>
    </modal-container>

</template>

<script>
    export default {
        data: function() {
            return {
                id: '',
                route: 'PRODUCT_DETAIL'
            }
        },
        methods: {
            sendExit: function(exitLoc) {
                let params = new URLSearchParams({
                  location: exitLoc,
                  id: this.id,
                  route: this.route,
                })

                this.$root.closeModal();

                window.location.replace("exit?" + params.toString())
            }
        },
        created: function() {
            this.id = this.$root.modalParams.id
        }
    }
</script>

<style scoped>
.prompt-container {
    margin: 0 2.8rem 1rem 2.8rem; /** override for text wrap **/
}
</style>
